// extracted by mini-css-extract-plugin
export default {"root":"MaskImageEditor_root__8yA8T","wrapper":"MaskImageEditor_wrapper__QkCk4"};